import { IconArrowBack } from '../Icons';
import styles from './Base.module.css';
import { useEffect, useRef, useState } from "react";

export function Base({
    Title,
    TitleDom,
    OnClose,
    OnLoad,
    ViewContent,
    ViewButtons,
    FullPopUp = false
}) {
    const refFixedContainer = useRef(null);
    const [state, setState] = useState(false);
    const [stateShowBase, setStateShowBase] = useState(false);

    async function BaseLoad() {
        await OnLoad?.()
        setStateShowBase(true)
    }

    useEffect(() => {
        if (!state) { setState(true) } else {
            document.documentElement.style.overflow = "hidden";
            BaseLoad();
            return () => { document.documentElement.style.overflow = "auto" }
        }
    }, [state])

    if (!stateShowBase) return null

    function onClickFixedContainer(e) { if (e.target === refFixedContainer.current) OnClose() }

    return (
        <section id='AlertPopUp_G_ID' ref={refFixedContainer} className={styles.FixedContainer} onClick={onClickFixedContainer}>
            <section className={`${styles.Container} ${FullPopUp ? styles.ContainerFull : undefined}`}>
                {FullPopUp && <IconArrowBack
                    color={'var(--cor_tooMe)'}
                    className={styles.IconArrowBack}
                    onClick={OnClose}
                />}
                <b className={styles.Title}>{Title}</b>
                {TitleDom}
                {ViewContent}
                {ViewButtons}
            </section>
        </section>
    );
}

export const HiddenAlertPopUp = () => {
    const AlertPopUp_G_ID = document.getElementById('AlertPopUp_G_ID');
    if (AlertPopUp_G_ID) {
        AlertPopUp_G_ID.style.display = 'none'
    }
}
export const ShowAlertPopUp = () => {
    const AlertPopUp_G_ID = document.getElementById('AlertPopUp_G_ID');
    if (AlertPopUp_G_ID) {
        AlertPopUp_G_ID.style.display = 'flex'
    }
}